import styled from 'styled-components';

import { CloseButton, ActionButton } from '../../sharedStyledComponents/Components';
import ButtonGoActive from '../../buttons/ButtonGoActive';

export const Background = styled.img`
  position: absolute;
  width: 472;
  height: 330;
  top: 112;
  left: 276;
`;

export const LargeBackground = styled.img`
  position: absolute;
  width: 673;
  height: 430;
  top: 62;
  left: 176;
`;

export const ContinueButton = styled(ActionButton)`
  position: absolute;
  width: 330;
  top: 393;
  left: 347;
`;

export const FailureText = styled.h2`
  position: absolute;
  width: 150;
  height: 34;
  top: 131;
  left: 437;
  text-align: center;
  font-size: 27;
  font-family: Quicksand Medium;
  color: #ffffff;
  margin: 0;
`;

export const DescriptionText = styled.p`
  position: absolute;
  width: 300;
  height: 68;
  top: 244;
  left: 362;
  text-align: center;
  font-size: 27;
  font-family: Quicksand Medium;
  color: #ffffff;
  margin: 0;
`;

export const GoButton = styled(ButtonGoActive)`
  position: absolute;
  top: 443;
  left: 387;
`;

export const SkillGamesIcon = styled.img`
  position: absolute;
  width: 124;
  height: 40;
  top: 81;
  left: 450;
`;

export const CloseModalButton = styled(CloseButton)`
  position: absolute;
  top: 75;
  left: 815;
  z-index: 1;
`;

export const GameIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 180px;
  margin: 10px;
`;

export const DecolineUpper = styled.img`
  position: absolute;
  width: 492;
  height: 17;
  top: 150;
  left: 266;
`;

export const DecolineLower = styled.img`
  position: absolute;
  width: 492;
  height: 17;
  top: 420;
  left: 266;
`;
